<template>
    <el-select v-model="modelValue" placeholder="请选择角色" @change="handleChange">
        <el-option v-if="isAllItem" label="全部" :value="''"></el-option>
        <el-option
            v-for="item in roleOptions"
            :key="item.id"
            :label="item.title"
            :value="item.id">
        </el-option>
    </el-select>
</template>
<script>
import { mapState, mapActions } from 'vuex'
export default {
    props: {
        value: {
            type: [String, Number],
            default: ''
        },
        isAllItem: {
            type: Boolean,
            default: true
        }
    },
    model: {
        prop: 'value',
        event: 'input'
    },
    data() {
        return {

        }
    },
    computed: {
        ...mapState({
            roleOptions: 'roleOptions'
        }),
        modelValue: {
            get(v) {
                return this.value
            },
            set(v) {
                this.$emit('input', v)
            }
        }
    },
    mounted() {
        this.getRoleOptions()
    },
    methods: {
        ...mapActions({
            getRoleOptions: 'getRoleOptions'
        }),
        handleChange(v) {
            this.$emit('change', v)
        }
    }
}
</script>
<style scoped lang="less">

</style>